/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react"; import { Accordion, AccordionItem, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";
import CheckBox from "../../../shared-ui/checkbox";
import { getFilterListValues } from "../../../../utils/getTags"
import Button from "../../../shared-ui/button";


// Infterface for Test Case Filter Component State
interface TestCaseFilterComponentState {
  isPopupOpen: boolean;
  iAgree: boolean;
  loading: boolean;
  result: any;
  error: object;
  isLangPopupOpen: boolean;
  contentTypeId: string;
  isTooltipOpen: boolean;
  closeFilter: boolean;
  onChangeselectedValue: any;
}

/**
 * Test Case Filter component.
 *
 * @namespace TestCaseFilterComponent
 */
class TestCaseFilterComponent extends React.Component<
  any,
  TestCaseFilterComponentState
> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      isPopupOpen: false,
      isLangPopupOpen: false,
      contentTypeId: "ms_pick_a_survey_page",
      iAgree: true,
      loading: true,
      result: [],
      error: {},
      isTooltipOpen: false,
      closeFilter: false,
      onChangeselectedValue: this.props.filterSelectedValue
    };
  }

  componentDidMount = () => {
    if (this.props.show) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, true);
      document.addEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        true
      );
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
      document.removeEventListener(
        "keydown",
        (e: any) => {
          if (e.key === "Escape") {
            this.handleOutsideClick(e);
          }
        },
        false
      );
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  /**
   * This method is used for handle language popup
   *
   */
  handleLangPopup = () => {
    this.setState({
      isLangPopupOpen: !this.state.isLangPopupOpen,
    });
  };

  /**
   * This method is used to handle pick survey popup close button
   *
   */
  handleClose = (e?: any) => {
    this.setState(
      {
        closeFilter: true,
      },
      () => {
        this.props.handleClose();
      }
    );
  };

  handleCheckboxvalue = (value: any) => {
    const { onChangeselectedValue } = this.state;
    const removeindex = onChangeselectedValue.indexOf(value);
    if (removeindex > -1) {
      onChangeselectedValue.splice(removeindex, 1);
      this.setState({
        onChangeselectedValue: onChangeselectedValue
      })
    }
    else {
      this.setState({
        onChangeselectedValue: [...onChangeselectedValue, value]
      })
    }
    // this.props.handleCheckboxvalue(value)
  }

  handleClearAllFilter = () => {
    this.setState({
      onChangeselectedValue: []
    })
  }

  handleApplyFilter = () => {
    this.setState({
      closeFilter: false
    }, () => {
      this.props.handleApplyFilter(this.state.onChangeselectedValue);
      this.props.handleClose();
    })
  }

  render() {
    const { onChangeselectedValue } = this.state;
    let animationClass = "test-filter-wrapper hide";

    if (this.state.closeFilter) {
      animationClass =
        "test-filter-wrapper animated slideInLeft close-pick-survey ";
    }
    if (this.props.show) {
      animationClass = "test-filter-wrapper animated slideInRight";
    }
    return (
      <>
        <div className={this.props.show ? "overlay" : "overlay hide"}></div>
        <div
          className={animationClass}
          ref={(node) => {
            this.node = node;
          }}
        >
          <div className="filter-header-area">
            {/* title is fetched here */}
            <div className="header-icon">
              <span
                tabIndex={0}
                role="button"
                aria-label="close tab"
                className="icon cross-icon"
                onClick={this.handleClose}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.handleClose(e);
                  }
                }}
              ></span>
            </div>
            <div className="header-title-area">
              <div className="title">Filter</div>
              <div className="clear-filter" onClick={() => this.handleClearAllFilter()}>Clear All Filters</div>
            </div>
          </div>

          {/* Middle Area Start */}
          <div className="middle-wrapper">

            {getFilterListValues && getFilterListValues.length > 0 && (
              <div className="custom-accordion">
                {/* Results With Accordion Start */}

                <Accordion allowZeroExpanded={true} allowMultipleExpanded={true}>
                  {getFilterListValues.map((listItem, index) => (
                    <AccordionItem>
                      <AccordionItemButton className="accordion_results_button">
                        <div className="item-btn-wrapper">
                          <div className="question-title">{Object.keys(listItem)}</div>
                          <div className={"handleArrow"}></div>
                        </div>
                      </AccordionItemButton>
                      <AccordionItemPanel className="accordion_results_panel">
                        {Object.values(listItem).map((item: any) => (
                          item.map((val: any, index: number) => (
                            <div className="options-area">

                              <CheckBox
                                onCheckboxClick={() => this.handleCheckboxvalue(val)}
                                className={'checkbox'}
                                isChecked={onChangeselectedValue?.some((selectedVal: any) => selectedVal === val)}
                              />
                              <div className="option">{val}</div>
                            </div>
                          ))
                        ))}
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
                {/* Accordion Area For Foods,Tips & Products Ends */}

                {/* Results With Accordion Ends */}
              </div>
            )}
          </div>
          {/* Middle Area Ends */}
          {/* Apply Button Area Start */}
          <div className="apply-container">
            <Button onButtonClick={() => this.handleApplyFilter()} name={"Apply Filter"} className={'app-btn'} />
          </div>
          {/* Apply Button Area Ends */}

        </div>
      </>
    );
  }
}

export default TestCaseFilterComponent;
